var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"enter-active-class":_vm.transitionEnterActiveClass,"mode":_vm.transitionMode,"name":_vm.transitionName}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }